import { Component, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { IonRouterOutlet } from '@ionic/angular'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { Page } from 'src/app/core/page'
import {
  IdealTypeQuizReportDetail,
  IdealTypeQuizReportDetailResponse,
  MBTI,
  MbtiIdealTypeMatchDetail,
  MbtiIdealTypeMatchDetailResponse,
  MbtiIdealTypeQuizReportDetail,
  MbtiIdealTypeQuizReportDetailResponse,
} from 'src/app/interfaces/mbti'
import { GeneralService } from 'src/app/services/general/general.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { MbtiService } from 'src/app/services/mbti/mbti.service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { RouterService } from 'src/app/services/router/router.service'
import { UserService } from 'src/app/services/user/user.service'

interface CharacteristicImage {
  type: 'female' | 'male'
  imageUrl: string
}

@Component({
  selector: 'app-ideal-type-dating-style',
  templateUrl: './ideal-type-dating-style.component.html',
  styleUrls: ['./ideal-type-dating-style.component.scss'],
})
export class DatingStyleComponent extends Page implements OnInit {
  constructor(
    public userService: UserService,
    protected generalService: GeneralService,
    protected routerService: RouterService,
    protected routerOutlet: IonRouterOutlet,
    protected modalService: ModalService,
    protected title: Title,
    protected logService: LogService,
    protected localeService: LocaleService,
    private activatedRoute: ActivatedRoute,
    private mbtiService: MbtiService
  ) {
    super(generalService, routerService, routerOutlet, modalService, title, logService, localeService)
  }

  screenName: string = 'ideal_dating_style'
  quizReport: IdealTypeResult | undefined
  characteristicImage: CharacteristicImage | undefined
  type: 'chemi' | 'quiz' | 'match' | undefined

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      if (params?.quizId && params?.type) {
        this.type = params?.type
        if (this.type === 'quiz') {
          this.quizReport = new IdealTypeQuizResult(this.mbtiService)
        } else if (this.type === 'match') {
          this.quizReport = new IdealMatchResult(this.mbtiService)
        } else {
          this.quizReport = new MbtiIdealTypeResult(this.mbtiService)
        }
      }
      if (params?.quizId && this.quizReport) {
        const id = params?.quizId
        this.quizReport.getQuizResult(+id).subscribe((res) => {
          if (res.data && this.quizReport) {
            this.quizReport.result = res.data
          }
        })
      }
    })
  }
}

abstract class IdealTypeResult {
  constructor(protected mbtiService: MbtiService) {}
  result: MbtiIdealTypeQuizReportDetail | IdealTypeQuizReportDetail | MbtiIdealTypeMatchDetail | undefined
  mbti: MBTI | undefined
  abstract getQuizResult(
    id: number
  ): Observable<
    MbtiIdealTypeQuizReportDetailResponse | IdealTypeQuizReportDetailResponse | MbtiIdealTypeMatchDetailResponse
  >
}

class MbtiIdealTypeResult extends IdealTypeResult {
  constructor(protected mbtiService: MbtiService) {
    super(mbtiService)
  }
  result: MbtiIdealTypeQuizReportDetail | undefined
  mbti: MBTI | undefined
  getQuizResult(id: number): Observable<MbtiIdealTypeQuizReportDetailResponse> {
    return this.mbtiService.getMbtiIdealTypeDetail(+id).pipe(
      tap((res) => {
        if (res.data) {
          this.mbti = res.data.myMbti?.mbtiType
        }
      })
    )
  }
}

class IdealMatchResult extends IdealTypeResult {
  constructor(protected mbtiService: MbtiService) {
    super(mbtiService)
  }
  result: MbtiIdealTypeMatchDetail | undefined
  mbti: MBTI | undefined
  getQuizResult(id: number): Observable<MbtiIdealTypeMatchDetailResponse> {
    return this.mbtiService.getMbtiIdealTypeMatchDetail(+id).pipe(
      tap((res) => {
        if (res.data) {
          this.mbti = res.data.mbtiQuiz?.mbtiType
        }
      })
    )
  }
}

class IdealTypeQuizResult extends IdealTypeResult {
  constructor(protected mbtiService: MbtiService) {
    super(mbtiService)
  }
  result: IdealTypeQuizReportDetail | undefined
  mbti: MBTI | undefined
  getQuizResult(id: number): Observable<IdealTypeQuizReportDetailResponse> {
    return this.mbtiService.getIdealTypeQuizHostInfo(+id).pipe(
      tap((res) => {
        if (res.data) {
          this.mbti = res.data.myMbti?.mbtiType
        }
      })
    )
  }
}
